import ct from "class-types.macro";
import React from "react";
import Carousel, { Item } from "~/common/Carousel";
import { Product } from "~/common/Store/models/ProductListing";
import CarouselMemberProduct from "../ProductBox/CarouselMemberProduct";

interface Props {
  carouselItems: readonly Product[];
}

export default function NewItemProductCarousel({ carouselItems }: Props) {
  return (
    <div
      className={ct(
        "rounded",
        "box-border",
        "flex",
        "flex-col",
        "mb-3",
        "w-full",
        "md:bg-gray-50",
        "md:border-gray-200",
        "md:border-solid",
        "md:border",
        "md:flex-row",
        "md:mb-5",
        "md:-mt-10",
        "md:p-5"
      )}
    >
      <div
        className={ct(
          "flex",
          "items-center",
          "justify-between",
          "mb-4",
          "md:mb-0",
          "md:w-2/5"
        )}
      >
        <div
          className={ct(
            "flex",
            "items-center",
            "justify-between",
            "w-full",
            "md:flex-col",
            "md:items-start",
            "md:pl-6",
            "lg:w-3/5"
          )}
        >
          <p
            className={ct(
              "font-semibold",
              "text-2xl",
              "leading-none",
              "mb-0",
              "md:text-5xl",
              "md:max-w-xs"
            )}
          >
            Recently Added{" "}
            <span className={ct("block", "font-normal", "text-lg", "md:mt-2")}>
              Browse our newest products
            </span>
          </p>
          <a
            href="/new/?order=date_desc"
            title=""
            className={`btn btn-info ${ct(
              "py-2",
              "md:mt-4",
              "md:py-3",
              "md:w-20"
            )}`}
            aria-label="Browse our newest products"
          >
            Shop All
          </a>
        </div>
        <div className={ct("hidden", "h-full", "relative", "w-2/5", "lg:flex")}>
          <img
            aria-hidden="true"
            src="//cdnimg.webstaurantstore.com/uploads/images/2021/5/newitemscarousel.png"
            className={ct(
              "my-auto",
              "-mr-2",
              "max-h-full",
              "absolute",
              "top-0",
              "right-0",
              "bottom-0"
            )}
            alt="Browse our newest products"
          />
        </div>
      </div>
      <div className={ct("md:w-3/5")}>
        <Carousel>
          {carouselItems.map((item) => (
            <Item
              classNames={ct("p-4", "w-32")}
              sliderRight
              key={item.itemNumber}
            >
              <CarouselMemberProduct {...item} isOutlet={false} />
            </Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
